module.exports = __webpack_public_path__ + "img/Back Office.5db5baf2.png";